import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { IModuleDefinition } from '@platform/core/types';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { ILawLabels } from './ILawLabels';

/** Підписи моделі закону (прототип v4 TRu — переклад значень словником): з рядків модуля, інакше з визначення, інакше значення як є. */
export function useLawLabels(module: IModuleDefinition): ILawLabels {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  return useMemo(() => {
    const rtOf = (key: string) => module.recordTypes.find((r) => r.key === key);
    const fieldOf = (key: string, field: string) => rtOf(key)?.fields.find((f) => f.key === field);
    return {
      option: (key, field, value) => {
        const v = value == null ? '' : String(value);
        return v ? strings.option(key, field, v, fieldOf(key, field)?.options?.find((o) => o.value === v)?.label) : '';
      },
      status: (key, value) => (value ? strings.status(key, value, rtOf(key)?.statuses.list.find((s) => s.value === value)?.label) : ''),
      name: (key) => strings.entity(key, 'name', rtOf(key)?.name ?? key),
      order: (key, field) => fieldOf(key, field)?.options?.map((o) => o.value) ?? [],
      article: (num) => t('recordPage.law.article', { num: num == null || num === '' ? '?' : String(num) }),
    };
  }, [module, strings, t]);
}
